import { type PhoneNumberData } from './FormikMultiPhoneNumbers.types';

const DEFAULT_NAME = 'phoneNumbers';

const TYPES = {
  LANDLINE: 'Landline',
  MOBILE: 'Mobile',
} as const;

const DEFAULT_PHONE_NUMBER_DATA = {
  countryCode: '',
  id: null,
  isDefault: false,
  number: '',
  remark: null,
  type: TYPES.MOBILE,
} as const satisfies PhoneNumberData;

const typesValues = Object.values(TYPES);

const typesSet = new Set<string>(typesValues);

export { DEFAULT_NAME, DEFAULT_PHONE_NUMBER_DATA, TYPES, typesSet, typesValues };
